// extracted by mini-css-extract-plugin
module.exports = {"name":"TimeLineSection_name__3pNEm","label":"TimeLineSection_label__YEiwr"};